import { Component, Inject, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';
import { MODAL_DATA } from '../../modal.service';

export interface ErrorPopupData {
  headerKey?: string;
  messageKey: string;
  hideHomepageLink?: boolean;
}

@Component({
    selector: 'gl-error-popup',
    templateUrl: './error-popup.component.html',
    styleUrls: ['./error-popup.component.scss'],
    standalone: false
})
export class ErrorPopupComponent {
  constructor(
    private modalRef: ModalOverlayRef,
    private router: Router,
    @Optional() @Inject(MODAL_DATA) public data?: ErrorPopupData,
  ) {
    this.modalRef.backgroundClicked();
  }

  public close(): void {
    this.modalRef.close();
  }

  public closeWithRedirect(): void {
    this.modalRef.close();
    this.router.navigate(['/']);
  }
}
